import { useQuery } from "@tanstack/react-query"

import { FINANCE_RETURN_STATUS_QUERY_KEY } from "@/constants/query"

const MOCK_DATA = [
  {
    id: 0,
    name: "В обработке"
  },
  {
    id: 1,
    name: "Выполнено"
  },
  {
    id: 2,
    name: "Отменён"
  }
]

export const useFinanceReturnStatusQuery = () => {
  return useQuery({
    queryFn: () => MOCK_DATA,
    queryKey: [FINANCE_RETURN_STATUS_QUERY_KEY]
  })
}